import { defineAsyncComponent } from 'vue';

const OPCustomerBalanceDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opCustomerBalance/OPCustomerBalanceDetail.vue')
);

const OPSupplierBalanceDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opSupplierBalance/OPSupplierBalanceDetail.vue')
);

const OPEmployeeBalanceDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opEmployeeBalance/OPEmployeeBalanceDetail.vue')
);

const OPBankAccountBalanceDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opBankAccount/OPBankAccountBalanceDetail.vue')
);

const OPCustomerBalanceListDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opCustomerBalance/OPCustomerBalanceListDetail.vue')
);

const OPSupplierBalanceListDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opSupplierBalance/OPSupplierBalanceListDetail.vue')
);

const OPEmployeeBalanceListDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opEmployeeBalance/OPEmployeeBalanceListDetail.vue')
);

const OPAccountBalanceDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opAccountBalance/OPAccountBalanceDetail.vue')
);

const OPAccountEntryPrevYearDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opAccountEntryPrevYear/OPAccountEntryPrevYearDetail.vue')
);

const OPAccountBalanceListDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opAccountBalance/OPAccountBalanceListDetail.vue')
);

const OPInventoryBalanceDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opInventory/OPInventoryBalanceDetail.vue')
);

const OPObjectBalanceListDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opAccountBalance/OPObjectBalanceListDetail.vue')
);

const OPObjectBalanceDetail = defineAsyncComponent(() =>
  import('@/views/initialBalance/accountBalance/opAccountBalance/OPObjectBalanceDetail.vue')
);


export function registerInitialBalance(app) {
  app.component('OPCustomerBalanceDetail', OPCustomerBalanceDetail);
  app.component('OPSupplierBalanceDetail', OPSupplierBalanceDetail);
  app.component('OPEmployeeBalanceDetail', OPEmployeeBalanceDetail);
  app.component('OPBankAccountBalanceDetail', OPBankAccountBalanceDetail);
  app.component('OPCustomerBalanceListDetail', OPCustomerBalanceListDetail);
  app.component('OPSupplierBalanceListDetail', OPSupplierBalanceListDetail);
  app.component('OPEmployeeBalanceListDetail', OPEmployeeBalanceListDetail);
  app.component('OPAccountBalanceDetail', OPAccountBalanceDetail);
  app.component('OPAccountBalanceListDetail', OPAccountBalanceListDetail);
  app.component('OPInventoryBalanceDetail', OPInventoryBalanceDetail);
  app.component('OPAccountEntryPrevYearDetail', OPAccountEntryPrevYearDetail);
  app.component('OPObjectBalanceListDetail', OPObjectBalanceListDetail);
  app.component('OPObjectBalanceDetail', OPObjectBalanceDetail);
}
